import { TIdTitle, TNameTitle } from '@interfaces/common/common';
import { TDefaultDTO } from '@interfaces/common/defaultDTO';
import { IKPISite, KpiAlertThreshold } from '@interfaces/kpi/kpiCommon';

import { TExportFileTypes, TVendorsValues } from '@enums/common';
import { TSeverity } from '@enums/kpi-common';

export interface IKpiAlertThresholdOutDTO {
	kpi: TIdTitle;
	operator1?: {
		name: string;
		symbol: string;
		title: string;
	};
	operator2?: {
		name: string;
		symbol: string;
		title: string;
	};
	minThreshold: number;
	maxThreshold: number;
}

export interface IOranNode {
	nodeId: string;
	cellIds: string[];
}

export enum EOranKpiAlertRecipientTypes {
	person = 'PERSON',
	group = 'GROUP',
}

export interface ICreateKpiAlertDTO {
	aggregationType: string;
	checkEveryHours?: number;
	checkEveryMinutes?: number;
	description?: string;
	evaluateHours?: number;
	evaluateMinutes?: number;
	isActive: boolean;
	isEmail: boolean;
	isNotification: boolean;
	kpiIds: string[];
	messageBody: string;
	messageTitle: string;
	name: string;
	notifyCondition: string;
	renotifyCondition?: string;
	renotifyHours?: number;
	renotifyMinutes?: number;
	roles: string[];
	severity: string;
	sites?: IKPISite[];
	nodes?: IOranNode[];
	technologies?: string[];
	thresholdApplication: string;
	thresholdSource: string;
	thresholds: KpiAlertThreshold[];
	users: string[];
	valuesOutsideThreshold: number;
	vendor: TVendorsValues;
	recipientType?: EOranKpiAlertRecipientTypes;
}

export interface IEditAlertDTO {
	id: string;
	description?: string;
	isActive: boolean;
	name: string;
	severity: TSeverity;
}

export interface IKpiAlertSeverityOutDTO extends TNameTitle<TSeverity, string> {
	color: string;
	weight: number;
}

export interface IKpiAlertSiteOutDTO {
	cellIds: string[];
	nodeId: string;
	siteId: string;
}

export interface IKpiAlertRecipientUserOutDTO {
	firstName: string;
	fullName: string;
	id: string;
	lastName: string;
}

export interface IKpiAlertDTO {
	id: string;
	aggregationType: TNameTitle;
	checkEveryHours: number;
	checkEveryMinutes: number;
	createdAt: number;
	description?: string;
	evaluateHours: number;
	evaluateMinutes: number;
	isActive: boolean;
	isEmail: boolean;
	isNotification: boolean;
	kpis: { id: string; title: string }[];
	messageBody: string;
	messageTitle: string;
	name: string;
	notifyCondition: TNameTitle;
	renotifyCondition: TNameTitle;
	renotifyHours: number;
	renotifyMinutes: number;
	roles: TNameTitle[];
	severity: IKpiAlertSeverityOutDTO;
	sites: IKpiAlertSiteOutDTO[];
	technologies: TNameTitle[];
	thresholdApplication: TNameTitle;
	thresholdSource: TNameTitle;
	thresholds: IKpiAlertThresholdOutDTO[];
	updateAt: number;
	users: IKpiAlertRecipientUserOutDTO[];
	valuesOutsideThreshold: number;
	vendor: TNameTitle;
	nodes?: IOranNode[];
}

export interface IGetKpiAlertsParamsDTO extends TDefaultDTO {
	severity: string | null;
	isActive: boolean | null;
}

export interface IKpiAlertHistoryOutDTO {
	description: string;
	happenedAt: number;
	happenedAtText: string;
	id: string;
	isActive: boolean;
	isSent: boolean;
	kpiAlertDbId: string;
	messageBody: string;
	name: string;
	organizationId: string;
	severity: IKpiAlertSeverityOutDTO;
}

export interface IGetKpiAlertsHistoryParamsDTO extends TDefaultDTO {
	description?: string;
	from?: number;
	fromText?: string;
	isActive?: boolean;
	isSent?: boolean;
	messageBody?: string;
	name?: string;
	organizationId?: string;
	severity?: string;
	vendor?: TVendorsValues | null;
}

export interface IKpiAlertHistoryExportFilterInRawDTO {
	from?: number;
	fromText?: string;
	isActive?: boolean;
	searchValue?: string;
	severity?: TSeverity | null;
	to?: number;
	toText?: boolean;
}

export interface IKpiAlertExportFilterInRawDTO {
	isActive: boolean;
	searchValue: string;
	severity: TSeverity;
}

export interface IKpiAlertHistoryExportDTO {
	fileType?: TExportFileTypes;
	filter?: IKpiAlertHistoryExportFilterInRawDTO;
	ids?: string[];
	isAll?: boolean;
	vendor?: TVendorsValues | null;
	onSuccess?: () => void;
}

export interface IKpiAlertExportDTO {
	fileType?: TExportFileTypes;
	filter?: IKpiAlertHistoryExportFilterInRawDTO;
	ids?: string[];
	isAll?: boolean;
	vendor?: TVendorsValues | null;
	onSuccess?: () => void;
}
